import React, {useEffect, useRef, useState} from "react";
import AGGrid from "../../Components/AGGrid";
import useStateWithCallback from "use-state-with-callback";
import EquipDamageRenderer from "../Organization/EquipDamageRenderer";
import {IAGrid} from "../../Components/IInterfaces";
import {CommonUtil} from "../../utils/CommonUtil";
import {NetworkManager} from "../../Components/NetworkManager";
import DetectDevice from "../../utils/DetectDevice";
import MGrid from "../../Components/MGrid";

const ReservationHistory = (props:any)=>{
    const { isMobile } = DetectDevice();
    const [equipHistory,setEquipHistory] = useStateWithCallback<any>([],()=>{});

    const [eqpColumnDefs] = useState([
        {field: 'changedField', headerName: 'Field', resizable: true, width: 200,sortable: true, filter: 'agNumberColumnFilter'},
        {field: 'fromValue', headerName: 'From Value', resizable: true, width: 200, sortable: true, filter: 'agNumberColumnFilter'},
        {field: 'toValue',headerName: 'To Value',resizable: true,width: 200,sortable: true,filter: 'agNumberColumnFilter'},
        {field: 'createdBy', headerName: 'Performed By', resizable: true, width: 150, flex: 1,sortable: true, filter: 'agTextColumnFilter'},
        {field: 'creationDate', headerName: 'Performed Date', tooltipField: 'creationDate',resizable: true, width: 200, sortable: true, filter: 'agTextColumnFilter',tooltip: (params:any) => 'Address: ' + params.value},
    ]);

    const gridRef = useRef<IAGrid>(null);

    useEffect(()=>{
        //console.log(props);
        if(CommonUtil.SELECT_EQUIP_ID){
            let historyAPI:string = "api/history?entityId="+CommonUtil.SELECT_RESERVATION_ID+"&entityName=equipment_reservation&saasOrgId="+CommonUtil.getSaasOrgId();
           // let obj:any = {};
            NetworkManager.sendJsonRequest(historyAPI,"","","GET",true,onGetEquipmentHistory,onLoginError);
        }
    },[])

    let onGetEquipmentHistory = (dataObj:any)=>{
        console.log(dataObj);
        let hisArray = [];
        if(dataObj) {
            var restData = CommonUtil.parseData(dataObj);
            if (restData) {
                if(Array.isArray(restData)){
                    hisArray = restData;
                }else{
                    hisArray.push(restData);
                }
            }
            hisArray.map((item:any,idx:number)=>{
                if(item &&   item.createdBy && item.createdBy.toString().split("#")){
                    item.createdBy =  item.createdBy.toString().split("#")[0]
                }

            })
        }
        setEquipHistory(hisArray);
    }

    let onLoginError = (dataObj:any)=>{
        console.log(dataObj);
    }

    return(
        <>
            <div className="container">
               <section>
                   <div className="row" style={isMobile ? {}:{paddingTop:"10px"}}>
                       {
                        isMobile ? (
                            <MGrid id="OrgReservationHistoryGrid" cols={eqpColumnDefs} rows={equipHistory} pageSize={10}
                                   headerHeight={CommonUtil.GRID_HEADER_HEIGHT} rowHeight={CommonUtil.GRID_ROW_HEIGHT}
                                   ref={gridRef} addNew={false} />
                        ):(
                            <div className="ag-theme-alpine gridHeight"
                            style={{height: 'calc(100vh - 250px)', width: '100%', paddingLeft: '0px', paddingRight: '0px'}} >
                           <AGGrid id="OrgReservationHistoryGrid" cols={eqpColumnDefs} rows={equipHistory} pageSize={500}
                                   headerHeight={CommonUtil.GRID_HEADER_HEIGHT} rowHeight={CommonUtil.GRID_ROW_HEIGHT}
                                   ref={gridRef} addNew={false} />
                       </div>
                        )
                       }
                   </div>
               </section>
            </div>
        </>
    );
}

export default ReservationHistory;